import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/elements";
import { Form, Field, CheckboxView, FormGroup, FirstName, LastName, Email } from "@grandvisionhq/forms";
import { Icon } from "@grandvisionhq/icons";
import { pushNewsletterEvent } from "../../../../data-layer/data-layer/newsletter.js";
const NewsletterForm = ({
  labels,
  showCancelButton,
  variant,
  authEmail,
  isSubscribeWithEmailChecked,
  isLoading,
  showSubscribeWithEmailError,
  onSubscribeWithEmailChange,
  onSubmit,
  onModalClose
}) => {
  const onHandleNewsletterEvent = () => {
    pushNewsletterEvent({ interactionType: "field_click" });
  };
  return /* @__PURE__ */ React.createElement(
    Form,
    {
      name: `newsletter-${variant}`,
      className: "newsletter__form",
      initialFormState: authEmail ? {
        email: {
          name: "email",
          value: authEmail,
          isTouched: true,
          isValid: true
        },
        subscribeWithEmail: {
          name: "subscribeWithEmail",
          value: "checked",
          isTouched: true,
          isValid: true
        }
      } : void 0,
      showErrorsOnInvalidSubmit: false,
      onSubmit,
      onBlur: onHandleNewsletterEvent
    },
    authEmail ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      Field,
      {
        name: "subscribeWithEmail",
        error: "",
        onChange: onSubscribeWithEmailChange
      },
      /* @__PURE__ */ React.createElement(
        CheckboxView,
        {
          id: "subscribeWithEmail",
          error: showSubscribeWithEmailError,
          label: labels.subscribeWithEmail,
          checked: isSubscribeWithEmailChecked,
          value: isSubscribeWithEmailChecked,
          onChange: () => null
        }
      )
    ), showSubscribeWithEmailError && /* @__PURE__ */ React.createElement("div", { className: "newsletter__error-container" }, /* @__PURE__ */ React.createElement(Icon, { name: "information-circle", height: 16, width: 16 }), /* @__PURE__ */ React.createElement(Text, { className: "newsletter__error-text", variant: "body" }, labels.subscribeWithEmailError))) : /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(FormGroup, { columns: 2 }, /* @__PURE__ */ React.createElement(FirstName, { required: false, label: labels.firstName, hideAsteriskSign: true }), /* @__PURE__ */ React.createElement(LastName, { required: false, label: labels.lastName, hideAsteriskSign: true })), /* @__PURE__ */ React.createElement(
      Email,
      {
        required: true,
        label: labels.emailAddress,
        errorMessage: labels.emailAddressErrorMessage
      }
    )),
    /* @__PURE__ */ React.createElement("div", { className: "newsletter__controls" }, /* @__PURE__ */ React.createElement(
      Button,
      {
        className: "newsletter__button",
        isLoading,
        caption: labels.signUp,
        type: "submit"
      }
    ), showCancelButton ? /* @__PURE__ */ React.createElement(
      Button,
      {
        className: "newsletter__button",
        variant: "outline",
        caption: labels.closeModal,
        onClick: onModalClose
      }
    ) : null)
  );
};
export {
  NewsletterForm as default
};
//# sourceMappingURL=NewsletterForm.js.map
